import React, { useState } from 'react';
import { Button, Snackbar, Alert, Box } from '@mui/material';
import { Refresh as RefreshIcon, Phone as PhoneIcon } from '@mui/icons-material';

const MobileUpdate: React.FC = () => {
  const [showUpdateButton, setShowUpdateButton] = useState(false);
  const [showMessage, setShowMessage] = useState(false);

  // Detectar si es móvil
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  React.useEffect(() => {
    // Mostrar botón solo en móviles
    if (isMobile) {
      setShowUpdateButton(true);
    }
  }, [isMobile]);

  const forceUpdate = async () => {
    try {
      // Limpiar caches
      const cacheNames = await caches.keys();
      for (const cacheName of cacheNames) {
        await caches.delete(cacheName);
      }

      // Desregistrar service workers
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (const registration of registrations) {
          await registration.unregister();
        }
      }

      // Limpiar storage
      localStorage.clear();
      sessionStorage.clear();

      setShowMessage(true);
      
      // Recargar después de 2 segundos
      setTimeout(() => {
        window.location.reload();
      }, 2000);

    } catch (error) {
      console.error('Error al actualizar:', error);
      setShowMessage(true);
    }
  };

  if (!showUpdateButton) {
    return null;
  }

  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          bottom: 16,
          left: 16,
          zIndex: 9999,
        }}
      >
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={forceUpdate}
          startIcon={<PhoneIcon />}
          sx={{
            borderRadius: '20px',
            boxShadow: 3,
            fontSize: '12px',
            padding: '8px 16px',
          }}
        >
          Actualizar PWA
        </Button>
      </Box>

      <Snackbar
        open={showMessage}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity="info">
          Actualizando aplicación... La página se recargará automáticamente.
        </Alert>
      </Snackbar>
    </>
  );
};

export default MobileUpdate; 